import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHeartFillComponent } from "./med-icon-heart-fill.component";

@NgModule({
  declarations: [
    MedIconHeartFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHeartFillComponent,
  ],
})
export class MedIconHeartFillModule { }
